import React from "react";
import { useBrand } from "../../context/BrandContext";

// Centralized brand mark: LOTUS + SERVICE symbol + Trust name + tagline.
// The Trust name & tagline are HTML text (never embedded in the logo image).
export default function Logo({ variant = "header" }) {
  const { symbol, compact, tagline, trustName } = useBrand();
  const isFooter = variant === "footer";
  const src = variant === "compact" ? compact : symbol;

  const symbolSize = {
    header: "h-12 w-12 sm:h-14 sm:w-14",
    compact: "h-10 w-10",
    footer: "h-14 w-14",
  }[variant] || "h-12 w-12";

  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <img src={src} alt="Sri Akilandeswari Amman Trust lotus and service symbol" className={`${symbolSize} shrink-0 object-contain`} />
      <span className="flex flex-col leading-tight">
        <span
          data-testid="brand-name"
          className={`whitespace-nowrap font-serif font-semibold tracking-wide ${isFooter ? "text-ivory text-sm sm:text-base" : "text-maroon text-sm sm:text-base lg:text-lg"}`}
        >
          {trustName}
        </span>
        <span
          data-testid="brand-tagline"
          className={`mt-0.5 text-[10px] sm:text-[11px] tracking-[0.16em] ${isFooter ? "text-gold-light" : "text-gold-dark"}`}
        >
          {tagline}
        </span>
      </span>
    </span>
  );
}
